export default "__VITE_ASSET__CoXK64$C__"